import React, { useState, useEffect } from 'react';
import './DailyNotification.css';
import { toEthiopianDate, amharicMonths, englishMonths } from '../../utils/dateConverter';

const DailyNotification = () => {
  const [isMinimized, setIsMinimized] = useState(true);
  const [todayData, setTodayData] = useState(null);
  const apiURL = process.env.REACT_APP_API_URL || '/api';

  useEffect(() => {
    const currentTime = new Date();
    const ethDate = toEthiopianDate(currentTime);
    const ecMonthName = englishMonths[ethDate.ecMonth - 1];
    const ecMonthNameAmharic = amharicMonths[ethDate.ecMonth - 1];

    // Fetch today's Sinksar directly from MongoDB
    fetch(`${apiURL}/content?type=sinksar&month=${ecMonthName}&day=${ethDate.ecDay}`)
      .then(res => res.json())
      .then(json => {
        if (json.success && json.data) {
          setTodayData({
            ...json.data,
            ecMonthNameAmharic,
            ecDay: ethDate.ecDay
          });
        }
      })
      .catch(err => {
        console.warn('Daily notification fetch failed:', err.message);
      });
  }, [apiURL]);

  if (!todayData) return null;

  if (isMinimized) {
    return (
      <button
        onClick={() => setIsMinimized(false)}
        className="fixed bottom-24 right-4 z-50 w-12 h-12 rounded-full bg-yellow-600 text-white shadow-lg flex items-center justify-center text-xl hover:bg-yellow-700 transition-all"
        title="የዛሬ በዓላት"
      >
        📌
      </button>
    );
  }

  return (
    <div className={`daily-notification`}>
      <div className="notification-header">
        <div className="notification-title">
          <span className="pin-icon">📌</span>
          <span>የዛሬ በዓላት</span>
        </div>
        <button 
          className="minimize-btn" 
          onClick={() => setIsMinimized(true)}
          title="አሳንስ"
        >
          ✕
        </button>
      </div>
      
      <div className="notification-content">
        <div className="notification-date">
          {todayData.ecMonthNameAmharic} {todayData.ecDay}
        </div>
        <div className="notification-saints">
          {todayData.title}
        </div>
        {todayData.content && Array.isArray(todayData.content) && todayData.content[0] && (
          <div className="notification-preview">
            {todayData.content[0].title || todayData.content[0].main?.substring(0, 80) + '...'}
          </div>
        )}
      </div>
      
      <div className="notification-footer">
        <a href="/sinksar" className="view-more-link">
          ሙሉውን አንብብ →
        </a>
      </div>
    </div>
  );
};

export default DailyNotification;
